var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08721 5.254C7.04954 5.29267 6.90731 5.458 6.77482 5.594C5.99807 6.44933 3.97177 7.84933 2.91121 8.27667C2.75014 8.34533 2.34293 8.49067 2.12537 8.5C1.91689 8.5 1.71816 8.452 1.52852 8.35467C1.29211 8.21867 1.10247 8.00467 0.998559 7.752C0.931665 7.57667 0.827752 7.052 0.827752 7.04267C0.723839 6.46867 0.666687 5.536 0.666687 4.50533C0.666687 3.52333 0.723839 2.62867 0.808918 2.046C0.818659 2.03667 0.922572 1.38467 1.03623 1.16133C1.2447 0.753333 1.65191 0.5 2.0877 0.5L2.12537 0.5C2.40918 0.51 3.00603 0.763333 3.00603 0.772667C4.00944 1.20067 5.98898 2.532 6.78456 3.41667C6.78456 3.41667 7.00863 3.644 7.10604 3.786C7.25802 3.99 7.33335 4.24267 7.33335 4.49533C7.33335 4.77733 7.24827 5.04 7.08721 5.254Z",
    fill: "#2C3782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCollapse);
export default __webpack_public_path__ + "static/media/ArrowRightCollapse.24a73aa0.svg";
export { ForwardRef as ReactComponent };